import { FC } from 'react';
import { Icon } from 'Components/UI';
import { MenuDivider, MenuDropdown, MenuGroup, MenuItemStyled } from './styles';

export interface IMoreFiltersActions {
  onPrintList: () => void;
  onPrintDetails: () => void;
  onExportCsv: () => void;
  onExportXml: () => void;
  onExportBcf: () => void;
  onImportBcf: () => void;
  onResetFilters: () => void;
  onCancel: () => void;
}

const MoreFiltersActions: FC<IMoreFiltersActions> = ({
  onPrintList,
  onPrintDetails,
  onExportCsv,
  onExportXml,
  onExportBcf,
  onImportBcf,
  onResetFilters,
  onCancel,
}) => {
  const handleAction = (action: () => void) => {
    action();
    onCancel();
  }

  return (
    <MenuDropdown>
      <MenuGroup>
        {/*
        <MenuItemStyled onClick={() => handleAction(onPrintList)}>
          <Icon
            icon="arquivo"
            customSize={16}
            className="clearFilters"
          />
          <span className="textItem">
            Imprimir Lista
          </span>
        </MenuItemStyled>
        */}

        <MenuItemStyled onClick={() => handleAction(onPrintDetails)}>
          <Icon
            icon="docEye"
            customSize={16}
            className="clearFilters"
          />
          <span className="textItem">
            Imprimir Detalhes
          </span>
        </MenuItemStyled>
      </MenuGroup>

      {/* <MenuDivider /> */}

      {/* <MenuGroup>
        <MenuItemStyled onClick={() => handleAction(onExportCsv)}>
          <Icon
            icon="download"
            customSize={16}
            className="clearFilters"
          />
          <span className="textItem">
            Exportar .CSV
          </span>
        </MenuItemStyled>

        <MenuItemStyled onClick={() => handleAction(onExportXml)}>
          <Icon
            icon="download"
            customSize={16}
            className="clearFilters"
          />
          <span className="textItem">
            Exportar .XML
          </span>
        </MenuItemStyled>

        <MenuItemStyled onClick={() => handleAction(onExportBcf)}>
          <Icon
            icon="download"
            customSize={16}
            className="clearFilters"
          />
          <span className="textItem">
            Exportar .BCF
          </span>
        </MenuItemStyled>
      </MenuGroup> */}

      {/* <MenuDivider /> */}

      {/* <MenuGroup>
        <MenuItemStyled onClick={() => handleAction(onImportBcf)}>
          <Icon
            icon="upload"
            customSize={16}
            className="clearFilters"
          />
          <span className="textItem">
            Importar .BCF
          </span>
        </MenuItemStyled>
      </MenuGroup> */}

      <MenuDivider />

      <MenuGroup>
        <MenuItemStyled onClick={() => handleAction(onResetFilters)}>
          <Icon
            icon="eraseFilter"
            customSize={16}
            className="clearFilters"
          />
          <span className="textItem">
            Redefinir filtros
          </span>
        </MenuItemStyled>
      </MenuGroup>
    </MenuDropdown>
  );
};

export default MoreFiltersActions;
